import React from 'react'
import { Container, Col, Row, Modal, Button, Form, Table } from 'react-bootstrap';
import AddNewArticles from './AddNewArticles';


class GenericInventory extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            origin_address: "",
            destination_address: "",
            origin_condition: "",
            destination_condition: "",
            articles: [],
            store_articles: [],
            showAddArticles: false,
        }
    }
    _renderTable = () => {
        const { articles } = this.state;
        if (articles.length > 0) {
            return (
                <Table striped bordered hover className={"mt-2"}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Article</th>
                            <th>Descriptive Symbols</th>
                            <th>Exception Symbols</th>
                            <th>Location Symbols</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this._renderArticles()}
                    </tbody>
                </Table>
            )
        }
    }
    _renderArticles = () => {
        const { articles } = this.state;
        if (articles.length > 0) {
            return articles.map((item, index) => {
                return (
                    <tr key={item.article + "" + index}>
                        <td>{index + 1}</td>

                        <td>{item.article}</td>
                        <td>{this._renderItems(item.descriptive_symbols)}</td>
                        <td>{this._renderItems(item.exception_symbols)}</td>
                        <td>{this._renderItems(item.location_symbols)}</td>
                    </tr>
                )
            })
        }
    }
    _renderItems = (items) => {
        console.log(items)
        if (items && items.length > 0) {
            return Object.keys(items).map((key, index) => {
                return (
                    <span key={key + "" + index} className={"ml-2"}
                        style={{ padding: 5, borderRadius: 50, borderWidth: 1, borderColor: "#eee" }}>
                        {items[key]}
                    </span>
                )
            })

        }
    }
    addNewItem = (item) => {
        this.setState({ articles: [...this.state.articles, item] })
    }
    render() {
        return (
            <Container className="">
                <h1>Generic Inventory</h1>
                <Row className={"p-2"}>

                    <Col md={12}>
                        <Row>
                            <Col md={6}><input type="text" style={{ marginTop: 5 }}
                                className="form-control"
                                value={this.state.origin_condition}
                                onChange={(event) => { this.setState({ origin_condition: event.target.value }) }}
                                name="origin_condition" placeholder='Origin condition'
                            /></Col>
                            <Col md={6}><input type="text" style={{ marginTop: 5 }}
                                className="form-control"
                                value={this.state.destination_condition}
                                onChange={(event) => { this.setState({ destination_condition: event.target.value }) }}
                                name="destination_condition" placeholder='Destination condition'
                            /></Col>

                        </Row>
                        <Row >
                            {this._renderTable()}
                        </Row>
                        <AddNewArticles {...this.props} addNewItem={this.addNewItem} />
                    </Col>




                </Row>

            </Container>
        )
    }
}

export default GenericInventory;

export { GenericInventory };